import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { useAuth } from '@/hooks/use-auth'
import { Button } from '@/components/ui/button'
import {
  LayoutDashboard,
  Package,
  TrendingUp,
  Users,
  Settings,
  Plus,
  BarChart3,
  User,
  Star,
  Download
} from 'lucide-react'

export const Route = createFileRoute('/dashboard')({
  component: DashboardComponent,
})

function DashboardComponent() {
  const { user } = useAuth()

  const navigation = [
    { name: 'Overview', to: '/dashboard', icon: LayoutDashboard },
    { name: 'My Algorithms', to: '/dashboard/algorithms', icon: Package },
    { name: 'Backtests', to: '/dashboard/backtests', icon: TrendingUp },
    { name: 'Profile', to: '/dashboard/profile', icon: User },
  ]

  if (user?.role === 'developer') {
    navigation.splice(3, 0, { name: 'Developer Portal', to: '/dashboard/developer', icon: Settings })
    navigation.splice(4, 0, { name: 'Analytics', to: '/dashboard/analytics', icon: BarChart3 })
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 min-h-screen bg-card border-r border-border">
          <div className="p-6">
            <div className="flex items-center space-x-3 mb-8">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <svg className="w-6 h-6 text-primary-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <h1 className="text-lg font-semibold text-foreground">Dashboard</h1>
                <p className="text-sm text-muted-foreground">{user?.name}</p>
              </div>
            </div>

            <nav className="space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon
                return (
                  <Link
                    key={item.name}
                    to={item.to}
                    className="flex items-center space-x-3 px-3 py-2 text-sm font-medium rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
                    activeProps={{
                      className: 'text-primary bg-primary/10',
                    }}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.name}</span>
                  </Link>
                )
              })}
            </nav>

            {user?.role === 'developer' && (
              <div className="mt-8 pt-8 border-t border-border">
                <Link to="/dashboard/developer/submit">
                  <Button className="w-full">
                    <Plus className="h-4 w-4 mr-2" />
                    Submit Algorithm
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  )
}